import React from 'react';
import { Box, FormControlLabel, Radio, Slider, Typography, Stack, RadioGroup } from '@mui/material';

import { OnlineLayoutSettings } from 'common/modules/customization';
import { useTranslation } from 'services/localization';
import FeaturedImageContainer from './FeaturedImageContainer';
import { useFormContext, Controller } from 'react-hook-form';
import { isValidButton } from 'common/modules/customization/utils';
import { FormValues } from '../types';
import CollapseSection from '../components/CollapseSection';

const Homepage = () => {
	const { t } = useTranslation();
	const { control, watch } = useFormContext<FormValues>();
	const defaultLayout = watch('onlineLayout.defaultLayout');
	const featuredImage = watch('onlineLayout.featuredImage');
	const isCategoriesLayout = defaultLayout === 'categories';

	return (
		<>
			{defaultLayout === 'categories' && (
				<Controller
					control={control}
					name="onlineLayout.featuredImage"
					rules={{
						validate: (value: OnlineLayoutSettings['featuredImage']) =>
							isValidButton(value?.button ?? null, t).valid,
					}}
					render={({ field }) => {
						return (
							<FeaturedImageContainer
								value={featuredImage}
								onChange={(featuredImage) => {
									field.onChange(featuredImage);
								}}
							/>
						);
					}}
				/>
			)}
			<CollapseSection
				id="layout-section"
				heading={t('channels.online.themeSettings.layout', 'Layout')}
			>
				<Stack mt={2}>
					<Controller
						control={control}
						name="onlineLayout.defaultLayout"
						render={({ field }) => {
							return (
								<RadioGroup aria-label="default-layout" {...field}>
									<FormControlLabel
										value="products"
										control={<Radio />}
										label={t('channels.online.themeSettings.productListing', 'Product listing')}
									/>
									<FormControlLabel
										value="categories"
										control={<Radio />}
										label={t('channels.online.themeSettings.categoryListing', 'Category listing')}
									/>
								</RadioGroup>
							);
						}}
					/>
				</Stack>
				<Stack>
					<Box mt={3}>
						<Typography variant="body2" sx={{ textTransform: 'uppercase', fontWeight: 400 }}>
							{isCategoriesLayout
								? t('channels.online.themeSettings.sliderHeaderCategories', 'Categories per row')
								: t('channels.online.themeSettings.sliderHeaderProducts', 'Products per row')}
						</Typography>
						<Box sx={{ display: 'flex', flexDirection: 'row', mt: 1 }}>
							<Controller
								control={control}
								name="onlineLayout.productGridColumns.desktop"
								render={({ field }) => {
									return (
										<>
											<Slider
												{...field}
												onChange={(_, value) => {
													field.onChange(value);
												}}
												aria-label="items-per-row"
												getAriaValueText={(value: number) => value.toString()}
												valueLabelDisplay="auto"
												step={1}
												min={1}
												max={12}
											/>
											<Typography ml={2}>{field.value}</Typography>
										</>
									);
								}}
							/>
						</Box>
					</Box>
				</Stack>
			</CollapseSection>
		</>
	);
};

export default Homepage;
